import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import InvestChartSC, { ChartTopSC, ChartWrapSC } from './invest-chart.styled';
import { ReactComponent as LeftArrow } from '../../../assets/img/svg/left-arrow-w.svg';
import { ReactComponent as RightArrow } from '../../../assets/img/svg/right-arrow-w.svg';
import { BodyText /*  SmallText */, SmallText } from '../../typography';
import { rgba } from 'polished';
import { graphic } from 'echarts';
import moment from 'moment';
import 'moment/min/locales';
import numeral from 'numeral';
import { COLOR_WHITE, COLOR_LIME_GREEN } from '../../../assets/styles/colors';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import chartDot from '../../../assets/img/svg/chart-dot.svg';
import useWindowSize from '../../../utils/screen-size';
import { BP_MOBILE_MIN } from '../../../assets/styles/breakpoints';

const switchTypes = [
  {
    id: 1,
    type: 'month',
    label: 'investor_dash_banner_chart_month',
  },
  {
    id: 2,
    type: 'year',
    label: 'investor_dash_banner_chart_year',
  },
  {
    id: 3,
    type: 'all',
    label: 'investor_dash_banner_chart_all',
  },
];

const _InvestChart = ({ appLanguage, chartData }) => {
  const [isSubtractButtonDisabled, setSubtractButtonDisabled] = useState(false);
  const [isAddButtonDisabled, setAddButtonDisabled] = useState(false);
  const [formattedChartData, setFormattedChartData] = useState(chartData);
  const [yearsToSelect, setYearsToSelect] = useState([]);
  const [monthsToSelect, setMonthsToSelect] = useState([]);
  const screenSize = useWindowSize();
  const isMobile = screenSize.width < BP_MOBILE_MIN;

  const [selectedValue, setSelectedValue] = useState({
    type: 'all',
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  useEffect(() => {
    if (selectedValue.type === 'year') {
      if (yearsToSelect[yearsToSelect.length - 1] === selectedValue.year) {
        setAddButtonDisabled(true);
      } else {
        setAddButtonDisabled(false);
      }
      if (selectedValue.year === yearsToSelect[0]) {
        setSubtractButtonDisabled(true);
      } else {
        setSubtractButtonDisabled(false);
      }
    } else if (selectedValue.type === 'month') {
      if (
        monthsToSelect[monthsToSelect.length - 1].year === selectedValue.year &&
        monthsToSelect[monthsToSelect.length - 1].month === selectedValue.month
      ) {
        setAddButtonDisabled(true);
      } else {
        setAddButtonDisabled(false);
      }

      if (
        selectedValue.month === monthsToSelect[0].month &&
        selectedValue.year === monthsToSelect[0].year
      ) {
        setSubtractButtonDisabled(true);
      } else {
        setSubtractButtonDisabled(false);
      }
    }
  }, [selectedValue, yearsToSelect, monthsToSelect]);

  useEffect(() => {
    moment.locale(appLanguage);
  }, [appLanguage]);

  useEffect(() => {
    if (chartData) {
      const filteredArx = chartData.reduce((acc, current) => {
        const x = acc.find(
          (item) =>
            new Date(item[0]).getFullYear() + `${new Date(item[0]).getMonth() + 1}` ===
            new Date(current[0]).getFullYear() + `${new Date(current[0]).getMonth() + 1}`
        );
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      const filteredArr = chartData.reduce((acc, current) => {
        const x = acc.find(
          (item) => new Date(item[0]).getFullYear() === new Date(current[0]).getFullYear()
        );
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      const listedYears = filteredArr.map((item) => {
        return new Date(item[0]).getFullYear();
      });
      const listedMonths = filteredArx.map((item) => {
        return { year: new Date(item[0]).getFullYear(), month: new Date(item[0]).getMonth() + 1 };
      });

      setYearsToSelect(listedYears);
      setMonthsToSelect(listedMonths);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeChartType = (type) => {
    if (chartData && chartData.length > 0) {
      const changedType = { ...selectedValue, type: type };
      switch (type) {
        case 'all':
          setSelectedValue(changedType);
          setFormattedChartData(chartData);
          break;
        case 'month':
          setSelectedValue({
            ...selectedValue,
            type: type,
            year: monthsToSelect[monthsToSelect.length - 1].year,
            month: monthsToSelect[monthsToSelect.length - 1].month,
          });
          setFormattedChartData(
            chartData.filter(
              (item) =>
                new Date(item[0]).getFullYear() ===
                  monthsToSelect[monthsToSelect.length - 1].year &&
                new Date(item[0]).getMonth() + 1 === monthsToSelect[monthsToSelect.length - 1].month
            )
          );
          break;
        case 'year':
          setSelectedValue({
            ...selectedValue,
            type: type,
            year: yearsToSelect[yearsToSelect.length - 1],
          });
          setFormattedChartData(
            chartData.filter(
              (item) => new Date(item[0]).getFullYear() === yearsToSelect[yearsToSelect.length - 1]
            )
          );
          break;
        default:
          break;
      }
    } else {
      return;
    }
  };

  const onChangeTimeClick = (val) => {
    const selectedYear = yearsToSelect.indexOf(selectedValue.year);

    const selectedMonth = monthsToSelect.findIndex(
      (x) => x.year === selectedValue.year && x.month === selectedValue.month
    );

    /* add time  */
    if (val === 'add') {
      if (selectedValue.type === 'year') {
        setSelectedValue({ ...selectedValue, year: yearsToSelect[selectedYear + 1] });
        setFormattedChartData(
          chartData.filter(
            (item) => new Date(item[0]).getFullYear() === yearsToSelect[selectedYear + 1]
          )
        );
      }
      if (selectedValue.type === 'month') {
        setSelectedValue({
          ...selectedValue,
          year: monthsToSelect[selectedMonth + 1].year,
          month: monthsToSelect[selectedMonth + 1].month,
        });
        setFormattedChartData(
          chartData.filter(
            (item) =>
              new Date(item[0]).getFullYear() === monthsToSelect[selectedMonth + 1].year &&
              new Date(item[0]).getMonth() + 1 === monthsToSelect[selectedMonth + 1].month
          )
        );
      }
    } else if (val === 'subtract') {
      /* subtract time  */
      if (selectedValue.type === 'year') {
        setSelectedValue({ ...selectedValue, year: yearsToSelect[selectedYear - 1] });
        setFormattedChartData(
          chartData.filter(
            (item) => new Date(item[0]).getFullYear() === yearsToSelect[selectedYear - 1]
          )
        );
      }
      if (selectedValue.type === 'month') {
        setSelectedValue({
          ...selectedValue,
          year: monthsToSelect[selectedMonth - 1].year,
          month: monthsToSelect[selectedMonth - 1].month,
        });
        setFormattedChartData(
          chartData.filter(
            (item) =>
              new Date(item[0]).getFullYear() === monthsToSelect[selectedMonth - 1].year &&
              new Date(item[0]).getMonth() + 1 === monthsToSelect[selectedMonth - 1].month
          )
        );
      }
    }
  };

  function getTooltipText(tooltipParams) {
    let percentages;

    if (tooltipParams[0].data[2] === 0) {
      percentages = '-';
    } else if (tooltipParams[0].data[2] > 0) {
      percentages = `+${numeral(tooltipParams[0].data[2]).format('0,00.00')} %`;
    } else {
      percentages = `-${numeral(tooltipParams[0].data[2]).format('0,00.00')} %`;
    }

    return `${moment(tooltipParams[0].data[0]).format('DD. MMMM')} </br> <b>${numeral(
      tooltipParams[0].data[1]
    ).format('0,0.00')} € </b>
    </br> 
    ${percentages}
    `;
  }

  const chartOptions = () => {
    return {
      grid: {
        left: 0,
        right: 22,
        top: 10,
        bottom: 0,
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        extraCssText:
          'text-transform: capitalize;box-shadow: 0 0 10px 0 rgba(12,233,100,0.4);border-top-right-radius:20px;border-bottom-right-radius:20px;font-size:12px;line-height:15px;padding:6px 20px 5px 16px;',
        backgroundColor: COLOR_LIME_GREEN,
        textStlye: {
          fontSize: 12,
          lineHeight: 26,
        },
        formatter(params) {
          return getTooltipText(params);
        },
        axisPointer: {
          type: 'line',
          snap: true,
          axis: 'auto',
          lineStyle: {
            color: COLOR_WHITE,
          },
          label: {
            show: false,
            backgroundColor: 'transparent',
            formatter(value) {
              if (value.axisDimension === 'x') {
                let fdate = '';
                if (selectedValue.type === 'all') {
                  fdate = moment(value.value).format('MMM YYYY');
                } else if (selectedValue.type === 'year') {
                  fdate = moment(value.value).format('MMM');
                } else {
                  fdate = moment(value.value).format('DD MMM');
                }

                return `${fdate} `;
              } else {
                let fprice = `${numeral(value.value).format('0,0.00')} €`;

                return `${fprice}`;
              }
            },
          },
        },
      },
      xAxis: {
        type: 'time',
        boundaryGap: false,
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: rgba(COLOR_WHITE, 0.1),
          },
        },
        axisLabel: {
          inside: false,
          color: rgba(COLOR_WHITE, 0.4),
          fontFamily: 'Source Sans Pro',
          formatter(date) {
            let fdate = '';
            if (selectedValue.type === 'all') {
              fdate = moment(date).format('MMM YYYY');
            } else if (selectedValue.type === 'year') {
              fdate = moment(date).format('MMM');
            } else {
              fdate = moment(date).format('DD MMM');
            }

            const uppercased = fdate.charAt(0).toUpperCase() + fdate.slice(1);
            return uppercased;
          },
        },
      },
      yAxis: {
        type: 'value',
        min: function(value) {
          const minNum = Number(value.min);
          return minNum;
        },
        max: function(value) {
          const maxNum = Number(value.max);
          return maxNum;
        },
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            color: rgba(COLOR_WHITE, 0.1),
            type: 'dashed',
          },
        },
        axisLine: {
          lineStyle: {
            color: rgba(COLOR_WHITE, 0.1),
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          inside: false,
          color: rgba(COLOR_WHITE, 0.4),
          fontFamily: 'Source Sans Pro',
          formatter(value) {
            return `${numeral(parseFloat(value)).format('0,0.00')} €`;
          },
        },
      },
      series: [
        {
          data: formattedChartData,
          type: 'line',
          symbol: `image://${chartDot}`,
          showAllSymbol: 'false',
          symbolSize: 8,
          hoverAnimation: true,
          itemStyle: {
            color: `${COLOR_LIME_GREEN}`,
          },
          areaStyle: {
            normal: {
              color: new graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: rgba(COLOR_LIME_GREEN, 0.5) },
                { offset: 1, color: rgba(COLOR_LIME_GREEN, 0) },
              ]),
            },
          },
        },
      ],
    };
  };

  return (
    <InvestChartSC>
      <ChartTopSC>
        <BodyText className="grey bolder">
          <FormattedMessage
            id="investor_dash_banner_chart_top"
            defaultMessage={dlt['investor_dash_banner_chart_top']}
          />
        </BodyText>

        <div className="chart-type-switch">
          {switchTypes.map((type) => {
            return (
              <button
                onClick={() => changeChartType(type.type)}
                key={type.id}
                className={type.type === selectedValue.type ? 'active' : ''}
              >
                {isMobile ? (
                  <FormattedMessage
                    id={`${type.label}_short`}
                    defaultMessage={dlt[`${type.label}_short`]}
                  />
                ) : (
                  <FormattedMessage id={type.label} defaultMessage={dlt[`${type.label}`]} />
                )}
              </button>
            );
          })}
        </div>

        <div className="chart-year-switch">
          <SmallText className="white bolder">
            {selectedValue.type === 'all' ? (
              <FormattedMessage
                id="investor_dash_banner_chart_all_datas"
                defaultMessage={dlt['investor_dash_banner_chart_all_datas']}
              />
            ) : selectedValue.type === 'year' ? (
              selectedValue.year
            ) : (
              moment(selectedValue.month, 'M').format('MMMM') + ' ' + selectedValue.year
            )}
          </SmallText>
          <div className="arrow-wrap">
            <button
              onClick={() => onChangeTimeClick('subtract')}
              disabled={
                selectedValue.type === 'all' ? true : isSubtractButtonDisabled ? true : false
              }
            >
              <LeftArrow />
            </button>
            <button
              onClick={() => onChangeTimeClick('add')}
              disabled={selectedValue.type === 'all' ? true : isAddButtonDisabled ? true : false}
            >
              <RightArrow />
            </button>
          </div>
        </div>
      </ChartTopSC>
      <ChartWrapSC>
        <ReactEcharts option={chartOptions()} style={{ height: '100%', width: '100%' }} />
      </ChartWrapSC>
    </InvestChartSC>
  );
};

const mapStateToProps = (state) => {
  return {
    appLanguage: state.app.language,
  };
};

const InvestChart = connect(mapStateToProps)(_InvestChart);

export default InvestChart;
